import { Promise } from './promise';
const status = state => value => ({
  state,
  value
});
export default (promises => Promise.all(promises.map(promise => promise.then(status('fulfilled')).catch(status('rejected')))));